import { useState } from "react";
import "./index.scss";
import "./_fonts.scss";

function WebDiscontinuePage() {

    // const [mobileNumber, setMobileNumber] = useState("");
    // const [error, setError] = useState("");
    // const [sentNumber, setSentNumber] = useState("");
    // const [fieldChange, setFieldChange] = useState(false);

    const ANDROID = 'https://play.google.com/store/apps/details?id=com.ryzmedia.tatasky';
    const IOS = 'https://apps.apple.com/in/app/tata-play-live-tv-dth-pack/id385090000';

    // const sendMobileNumber =async()=>{
    //     if (!mobileNumber) return  setError("*Please Enter a Valid Phone Number");
        
    //       // validation
    //       if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
    //         setError("*Please Enter a Valid Phone Number");
    //         return;
    //       }

    //       setError("");
    //       setSentNumber(mobileNumber);
    //       setFieldChange(true);

    //       try {
    //         const payload = {
    //           mobile: mobileNumber
    //         };
        
    //         console.log("Payload:", payload);
        
    //         // API call example
    //         // await axios.post('/api/send-link', payload);
        
    //       } catch (error) {
    //         console.log("API error", error);
    //       }
    // }

    // const maskMobileNumber=(number) => {
    //     return `${number.slice(0, 3)}xxxxx${number.slice(-3)}`;
    // }
    // const reSendMobileNumber =()=>{
    //     console.log("Resend mobile number",mobileNumber);
    // }
  return (
    <div className="webdiscontinued-wrapper">
        <div className="webdiscontinued-header">
            <div className="tataplay-logo">
                    <img src="/Images/logo.png" alt="Tata-Play-Logo" className="logo"/>
            </div>
            <div className="primart-container">
                    <div className="middle-container">
                        <div className="left-container">
                            
                                <p className="header-part">Your favourite shows are now available on Tata Play Mobile App.</p>
                            <div className="inner-container">
                                    <div className="inner-left-container">
                                        <div className="logo-item-container">
                                            <img src="/Images/discontinuedMovies.svg" className="logo-item" alt="movies-logo"/>
                                            <p className="text-item">600+ live TV channels</p>
                                        </div>
                                        <div className="logo-item-container">
                                            <img src="/Images/discontinuedTv.svg" className="logo-item" alt="Tv-logo"/>
                                            <p className="text-item">Faster streaming in HD</p>
                                        </div>
                                    </div>
                                    <div className="inner-right-container">
                                        <div className="logo-item-container">
                                            <img src="/Images/discontinuedPacks.svg" className="logo-item" alt="Pack-logo"/>
                                            <p className="text-item">Managing account with ease</p>
                                        </div>
                                        <div className="logo-item-container">
                                            <img src="/Images/discontinuedLocation.svg" className="logo-item" alt="Location-logo"/>
                                            <p className="text-item">Watching anywhere, anytime</p>
                                        </div>
                                    </div>
                                
                            </div>
                        </div>
                        <div className="right-container">
                            <img src="/Images/mobileApp.png" className="mobile-logo" alt="mobile-img" priority/>
                        </div>
                    </div>
                    
            </div>
        </div>
        <div className="webdiscontinued-footer">
            <div className="ft-header">
                <p>Choose a way to download and continue enjoying:</p>
            </div>
            <div className="items-container">
                <div className="items qr-items">
                    <img src="/Images/scanner.png" className="qr-code" alt="QR-code"/>
                    <div className="qr-text">Scan QR code </div>
                    <span className="line1"><img src="/Images/line.svg" alt="line"/></span>

                </div>
                <div className="items download-items">
                    <div className="download-text">Download from:</div>
                    <div className="app-store">
                        <div className="app-btn" onClick={()=>window.open(ANDROID, '_blank')}>
                            <img src="/Images/playStore.svg" alt="android-img"/>
                        </div>
                        <div className="app-btn" onClick={()=>window.open(IOS, '_blank')}>
                            <img src="/Images/appStore.svg" alt="ios-img"/>
                        </div>
                    </div>
                    {/* <span className="line2"><img src="/Images/line.svg"  alt="line"/></span> */}
                </div>
                {/* <div className="items link-items">
                    <div className="link-text">Get download link on phone:</div>
                    <div className="inupt-container">
                        {
                            fieldChange ?
                            <>
                                <div className="check-messgae-container">
                                        <img src="/Images/check.svg" alt="tick-mark"/>
                                        <p>Link sent on {maskMobileNumber(sentNumber)}</p>
                                </div>
                                <div className="resend-btn" onClick={()=>reSendMobileNumber()}>
                                    <p>Resend</p>
                                </div>
                            </>
                            :
                            <>
                                <input type="tel"
                                className={`input-box ${error ? "error-border" : ""}`}
                                placeholder="Enter mobile number"
                                maxLength={10}
                                value={mobileNumber}
                                onChange={(e)=>{
                                    setMobileNumber(e.target.value);
                                    setError("");
                                    }
                                }
                                />
                                {error && <span className="error-text">{error}</span>}
                                <div className="get-link-btn" onClick={()=>sendMobileNumber()}>
                                     <p>Get Link</p>
                                </div>
                            </>
                        }
                    </div>
                </div> */}
            </div>
        </div>
    </div>
    )
}    

export default WebDiscontinuePage;
